import { TimeCloserRankingTable } from '@/components/Dashboard/TimeCloserRankingTable'
import { TimeKpiGrid } from '@/components/Dashboard/TimeKpiGrid'
import { TimePipelineChart } from '@/components/Dashboard/TimePipelineChart'
import type { TimeTabView } from '@/components/Dashboard/timeTab.utils'
import {
  formatDashboardCurrency,
  formatDashboardNumber,
} from '@/utils/crmValuesDisplay'

type Props = {
  view: TimeTabView
  valuesVisible?: boolean
}

export function TimeTab({ view, valuesVisible = false }: Props) {
  return (
    <div className='space-y-6'>
      <p className='text-sm text-text-muted'>
        Performance da equipe comercial — meta coletiva, fechamentos por closer e resumo do pipeline.
      </p>

      <TimeKpiGrid view={view} valuesVisible={valuesVisible} />

      <div className='grid grid-cols-1 gap-4 xl:grid-cols-3'>
        <div className='xl:col-span-2'>
          <TimePipelineChart view={view} valuesVisible={valuesVisible} />
        </div>
        <aside className='flex flex-col gap-4 rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] p-5 shadow-sm'>
          <div>
            <h3 className='text-base font-semibold text-text-primary'>Resumo do time</h3>
            <p className='mt-1 text-sm text-text-muted'>Indicadores consolidados no período</p>
          </div>
          <dl className='space-y-3 text-sm'>
            <div className='flex items-center justify-between gap-3 border-b border-[var(--border)] pb-3'>
              <dt className='text-text-secondary'>Receita fechada</dt>
              <dd className='font-semibold tabular-nums text-text-primary'>
                {formatDashboardCurrency(view.closedRevenue, valuesVisible)}
              </dd>
            </div>
            <div className='flex items-center justify-between gap-3 border-b border-[var(--border)] pb-3'>
              <dt className='text-text-secondary'>Pipeline total</dt>
              <dd className='font-semibold tabular-nums text-text-primary'>
                {formatDashboardCurrency(view.pipelineTotalValue, valuesVisible)}
              </dd>
            </div>
            <div className='flex items-center justify-between gap-3 border-b border-[var(--border)] pb-3'>
              <dt className='text-text-secondary'>Deals abertos</dt>
              <dd className='font-semibold tabular-nums text-text-primary'>
                {formatDashboardNumber(view.pipelineTotalCount, valuesVisible)}
              </dd>
            </div>
            <div className='flex items-center justify-between gap-3'>
              <dt className='text-text-secondary'>Closers ativos</dt>
              <dd className='font-semibold tabular-nums text-text-primary'>
                {formatDashboardNumber(view.totalClosers, valuesVisible)}
              </dd>
            </div>
          </dl>
        </aside>
      </div>

      <TimeCloserRankingTable view={view} valuesVisible={valuesVisible} />
    </div>
  )
}
